import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import colors from '../styles/colors';
import Card from './Card';
import { GET_CURRENT_PAYMENT_INFO } from '../graphql/queries';
import BaseModal, { ModalList } from './modals/BaseModal';
import Loader from './Loader';

const BillingContainer = styled.div`
flex-direction: column;
display:flex;
justify-content: center;
align-items: center;
`;

const Text = styled.div`
  font-size: 1.2rem;
  color: ${colors.grey3};
  margin-bottom: 10px;
`;

const TextLink = styled.div`
  text-decoration: underline;
  font-size: 1.2rem;
  color: ${colors.seaGreen};
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s;
  width: fit-content;

  &:hover {
    text-decoration: none;
  }
`;

const PaymentText = styled.div`
  color: ${colors.grey1};
  font-style: italic;
  font-size: 1.4rem;
  margin-bottom: 10px;
`;

export default function PaymentMethodCard() {
  const [changeModalIsVisible, setChangeModalIsVisible] = useState(false);
  const [cancelAccountModalIsVisible, setCancelAccountModalisVisible] = useState(false);
  const { data, loading } = useQuery(GET_CURRENT_PAYMENT_INFO);

  const c = data?.getCurrentPaymentInfo;

  return (
    <>
      <BaseModal
        open={changeModalIsVisible}
        modalType={ModalList.ChangePaymentMethod}
        onClose={setChangeModalIsVisible}
      />
      <BaseModal
        open={cancelAccountModalIsVisible}
        modalType={ModalList.CancelAccount}
        onClose={setCancelAccountModalisVisible}
      />
      <Card width="100%" height="100px" margin="0px 0px 25px 0px">
        <BillingContainer>
          {loading ? <Loader /> : (
            <>
              <Text>
                CURRENT PAYMENT METHOD
              </Text>
              <PaymentText>
                {`${c?.brand} ${c?.last4} - Exp. ${c?.expMonth}/${c?.expYear}`}
              </PaymentText>
              <TextLink onClick={() => setChangeModalIsVisible(true)}>
                Change
              </TextLink>
              <TextLink onClick={() => setCancelAccountModalisVisible(true)}>
                Cancel account
              </TextLink>
            </>
          )}
        </BillingContainer>
      </Card>
    </>
  );
}
